

document.addEventListener('DOMContentLoaded', function() {
    // Inicializações
    initializeVideoHandlers();
    monitorAddButton();
//  moveBtnFloat();

  
    // Adicione outras funções de inicialização aqui
});

window.addEventListener('load', function() {
            setTimeout(function() {
            alterZIndex('[data-mbz-button-popup-wrapper]', 28);
          }, 3000); // Executa a ação após 100 milissegundos

});

/*
function moveBtnFloat(){
  var button = document.querySelector('.btn-floating');

if (button) {
    document.body.appendChild(button);
} else {
    console.log("Botão não encontrado");
}
}

*/
/** -- FUNÇÕES PARA EXIBIÇÃO DO VIDEO DO SMART NA PAGINA DO CÃO. --*/
/**Inicializa os manipuladores de eventos relacionados ao vídeo.*/
function initializeVideoHandlers() {
    const watchDemoVideo = document.querySelector('.watch_demo_video');
    const videoDemoSmart = document.getElementById('videoDemoSmart');
    const closeVideoBtn = document.querySelector('.videoDemoSmart__close');
    const videoElement = document.getElementById('videoElement');
    
    if (watchDemoVideo) {
        watchDemoVideo.addEventListener('click', showVideo);
    }

    if (closeVideoBtn && videoElement) {
        closeVideoBtn.addEventListener('click', closeVideo);
    }
}
/** Exibe o vídeo.*/
function showVideo() {
    const videoDemoSmart = document.getElementById('videoDemoSmart');
    if (videoDemoSmart) {
        videoDemoSmart.style.display = 'block';
    }
}
/**Oculta o vídeo e reinicia sua reprodução.*/var button = document.querySelector('button[name="add"]');
function closeVideo() {
    const videoDemoSmart = document.getElementById('videoDemoSmart');
    const videoElement = document.getElementById('videoElement');
    if (videoDemoSmart) {
        videoDemoSmart.style.display = 'none';
    }
    videoElement.pause();
    videoElement.currentTime = 0;
}



/** -- FUNÇÕES PARA EXIBIÇÃO DO BOTÃO FLUTUANTE DO RODAPÉ. --*/
/**Monitora o botão 'add' para verificar se ele saiu da tela pela parte de cima.*/
function monitorAddButton()  {
    const addButton = document.querySelector('button[name="add"]');
    const floatingButton = document.querySelector('.btn-floating');

    if (!addButton || !floatingButton) {
        console.warn('Botão "add" ou "btn-floating" não encontrado.');
        return;
    }

    // Verifica a posição do botão quando a página é rolada
    window.addEventListener('scroll', function() {
        if (isOutOfView(addButton)) {
            showFloatingButtonSmoothly(floatingButton);
        } else {
            hideFloatingButtonSmoothly(floatingButton);
        }
    });
}

/**
 * Verifica se o elemento saiu da tela pela parte de cima.
 * @param {Element} element - O elemento a ser verificado.
 * @return {boolean} - Retorna true se o elemento saiu da tela pela parte de cima.
 */
function isOutOfView(element) {
    const rect = element.getBoundingClientRect();
    return rect.bottom < 0;
}

/**
 * Mostra o botão flutuante suavemente.
 * @param {Element} button - O botão a ser exibido.
 */
function showFloatingButtonSmoothly(button) {
    button.style.opacity = '1';
    button.style.zIndex  = '25';
}

/**
 * Oculta o botão flutuante suavemente.
 * @param {Element} button - O botão a ser ocultado.
 */
function hideFloatingButtonSmoothly(button) {
    button.style.opacity = '0';
    button.style.zIndex  = '-100';
}

function alterZIndex(selector, newValue) {
    // Seleciona o elemento com base no seletor fornecido
    const element = document.querySelector(selector);
    console.log('trocando zindex de ' + element )
    // Se o elemento existir, altera o valor do z-index
    if (element) {
        element.style.zIndex = newValue;
      console.log('trocando zindex de ' + selector )
    }
}
//============================================================================


